<div class="avi-health-score-faults">
    <span class="avi-health-score-faults__header">
        <cds-icon
            class="avi-health-score-faults__icon"
            shape="exclamation-triangle"
            solid="true"
        ></cds-icon>
        <a
            (click)="toggleList()"
            class="avi-health-score-faults__count"
        >
            <strong *ngIf="!isServiceEngine">
                {{ l10nKeys.virtualServiceFaultDetectedPlural | vtranslate : count }}
            </strong>
            <strong *ngIf="isServiceEngine">
                {{ l10nKeys.serviceEngineFaultDetectedPlural | vtranslate : count }}
            </strong>
        </a>
    </span>
    <div
        *ngIf="showList"
        class="avi-health-score-faults__description"
    >
        <ul class="avi-health-score-faults__fault-list">
            <li
                *ngFor="let genericFault of genericFaults; trackBy: trackByIndex"
                class="avi-health-score-faults__generic-fault"
            >
                <div class="avi-health-score-faults__fault-content">
                    <span
                        *ngFor="let fault of genericFault.faults; trackBy: trackByIndex"
                        class="avi-health-score-faults__fault-description"
                    >
                        <span class="avi-health-score-faults__fault-text">{{ fault.description }}</span>
                    </span>
                </div>
            </li>
            <li
                *ngIf="serverFaults?.faults?.length"
                class="avi-health-score-faults__server-fault-header"
            >
                <div class="avi-health-score-faults__server-fault-title">{{ l10nKeys.serverFaultsLabel | vtranslate }}</div>
            </li>
            <li
                *ngFor="let serverFault of serverFaults?.faults; trackBy: trackByIndex"
                class="avi-health-score-faults__server-fault"
            >
                <div class="avi-health-score-faults__server-fault-content">
                    <span class="avi-health-score-faults__pool-name">{{ serverFault.pool_ref.name() }}:</span>
                    <span
                        *ngFor="let fault of serverFault.servers; trackBy: trackByIndex"
                        class="avi-health-score-faults__server-fault-description"
                    >
                        <span class="avi-health-score-faults__server-fault-text">{{ fault.description }}</span>
                    </span>
                </div>
            </li>
        </ul>
    </div>
</div>
